import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-todos',
  styles: [`
    :host {
      display:block;
      padding:8px;
    }
    .nns-todo-item {
      border-bottom:1px solid #dcdcdc;
      font-size:14px;
      padding:16px 8px;
    }
    .nns-todo-item:first {padding-top:8px;}
    .nns-todo-item-close {
      color: #9DA5A6;
      text-decoration:line-through;
    }
  `, `
    :host-context(.nns-theme-night) .nns-todo-item {border-color:rgba(0,0,0,0.12);}
  `],
  template: `
    <div *ngFor="let todo of todosUnchecked" class="nns-todo-item">
      {{todo.label}}
    </div>
    <div *ngFor="let todo of todosChecked" class="nns-todo-item nns-todo-item-close">
      {{todo.label}}
    </div>
  `
})
export class TodosComponent {
  @Input() todos = [];
  @Input() todosOrder = [];
  todosChecked = [];
  todosUnchecked = [];

  ngOnChanges(changes) {
    this.prepareTodos();
  }

  prepareTodos() {
    if (!this.todos) {
      this.todosChecked = [];
      this.todosUnchecked = [];
      return;
    }
    let todosChecked = this.todos.filter((x) => !!x.checked);
    let todosUnchecked = this.todos.filter((x) => !x.checked);

    if (this.todosOrder) {
      todosUnchecked = todosUnchecked.sort(this.comparer.bind(this));
      todosChecked = todosChecked.sort(this.comparer.bind(this));
    }
    this.todosChecked = todosChecked;
    this.todosUnchecked = todosUnchecked;
  }

  comparer(todoA, todoB) {
    const todoIdA = todoA.globalId;
    const todoIdB = todoB.globalId;
    const orderA = this.todosOrder.indexOf(todoIdA);
    const orderB = this.todosOrder.indexOf(todoIdB);
    if (orderA === -1 && orderB === -1) {
      return this.todos.indexOf[todoIdA] - this.todos.indexOf[todoIdB];
    }
    return orderA - orderB;
  }
}
